import PropTypes from 'prop-types';
import React from 'react';
import { Nav } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { additionalMenuItems, defaultMenuItems } from '../../config/menu';
import NavItem from './NavItem';

const menuItems = [...defaultMenuItems, ...additionalMenuItems];

/**
 * Sidebar navigation items component
 * @param {Object} props - Component props
 * @param {boolean} props.sidebarShow - Controls sidebar visibility
 */
const SidebarItems = ({ sidebarShow }) => {
  const { pathname } = useLocation();

  const isItemActive = (item) => {
    return !item.external && (item.isActiveCheck?.(pathname) ?? pathname === item.path);
  };

  return (
    <Nav as="ul" className="responsive-scroll">
      {menuItems.map((item) => (
        <NavItem
          key={item.path}
          item={item}
          isActive={isItemActive(item)}
          sidebarShow={sidebarShow}
        />
      ))}
    </Nav>
  );
};

SidebarItems.propTypes = {
  sidebarShow: PropTypes.bool.isRequired,
};

export default SidebarItems;
